<template></template>

<script>
import { handleRedirect } from '../../services/auth';

export default {
  async created() {
    // reset template list cookies
    sessionStorage.removeItem('editor_page');
    sessionStorage.removeItem('report_page');
    sessionStorage.removeItem('inspector_page');
    sessionStorage.removeItem('publisher_page');

    this.$cookies.remove('editor_page_lastKey');
    this.$cookies.remove('report_page_lastKey');
    this.$cookies.remove('publisher_page_lastKey');
    this.$cookies.remove('inspector_page_lastKey');

    await handleRedirect();
  },
};
</script>

<style></style>
